import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_1.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/nova');
  const shareText = encodeURIComponent('At Novac Technology Solutions, innovation meets people-first practices to create an outstanding workplace!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Novac Technology Solutions — Outstanding Workplaces</title>
        <meta property="og:title" content="Novac Technology Solutions — Outstanding Workplaces" />
        <meta property="og:description" content="At Novac Technology Solutions, innovation meets people-first practices to create an outstanding workplace." />
        <meta property="og:image" content="https://outstandingworkplaces.co/assets/i_1.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/nova" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Novac Technology Solutions — Outstanding Workplaces" />
        <meta name="twitter:description" content="At Novac Technology Solutions, innovation meets people-first practices to create an outstanding workplace." />
        <meta name="twitter:image" content="https://outstandingworkplaces.co/assets/i_1.jpg" />
      </Helmet>

      <div className="sight_1_page_wrapper">
        <div className="sight_1_content_container">

          <div className="sight_1_section_one">

            <h1 className="sight_1_page_title">
              At Novac Technology Solutions, innovation meets people-first practices to create an outstanding workplaces.
            </h1>

            <div className="sight_1_row">

              <div className="sight_1_left">
                <div className="sight_1_image_wrapper">
                  <img src="/assets/i_1.jpg" alt="Team meeting discussion" className="sight_1_blog_image" />
                  <img src="/assets/bg_1.png" className="sight_1_left_badge" alt="" />
                </div>

                {/* SHARE SECTION */}
                <div className="sight_1_share_section">
                  <span className="sight_1_share_text">Share :</span>
                  <div className="sight_1_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_1_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_1_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_1_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_1_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

                <p className="sight_1_intro_paragraph">
                  At Outstanding Workplaces, we recognize organizations that build strong cultures through innovation, leadership, and meaningful employee experiences.
                </p>
              </div>

              <div className="sight_1_right">
                <div className="sight_1_ad_card">
                  <img src="/assets/bc_1.png" className="sight_1_ad_bg" alt="" />
                  <div className="sight_1_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_1_ad_badge" alt="" />
                  <div className="sight_1_ad_content">
                    <h2>Earn the Outstanding <br /><span>Workplaces Certification</span></h2>
                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>
                    <button
                      className="sight_1_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* ====== SECTION TWO ====== */}
          <div className="sight_1_section">

            <ul className="sight_1_intro_list">
              <li>Novac Technology Solutions exemplifies this approach by combining people-first values with cutting-edge technology to drive excellence across industries.</li>
            </ul>

            <div className="sight_1_topics">

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">Building an Outstanding Workplace Through Innovation and Purpose</h2>
                <ul className="sight_1_topic_list">
                  <li>Explore how Novac Technology Solutions blends innovation with a strong sense of purpose to create a workplace where people thrive and ideas flourish.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">Inside Novac Technology Solutions: A Culture Driven by Creativity and Integrity</h2>
                <ul className="sight_1_topic_list">
                  <li>A deep dive into Novac's unique workplace culture, rooted in integrity, collaboration, and continuous innovation.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">Leadership That Inspires: How Novac Nurtures Future-Ready Leaders</h2>
                <ul className="sight_1_topic_list">
                  <li>Highlight internal leadership grooming practices, mentoring models, and growth opportunities for emerging leaders.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">People-First Practices That Power Business Excellence</h2>
                <ul className="sight_1_topic_list">
                  <li>Showcase how employee experience, wellbeing, and engagement directly contribute to Novac's business success.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">Innovation as a Mindset: Empowering Teams to Think Beyond Boundaries</h2>
                <ul className="sight_1_topic_list">
                  <li>Discuss how Novac encourages experimentation, creativity, and adoption of emerging technologies across teams.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">Learning, Growth, and Transformation at Novac Technology Solutions</h2>
                <ul className="sight_1_topic_list">
                  <li>Focus on continuous learning initiatives, skill development, and career progression opportunities within the organization.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">Creating Impact Across Industries Through a Strong Workplace Culture</h2>
                <ul className="sight_1_topic_list">
                  <li>Connect Novac's workplace practices with its success in Financial Services, Insurance, Digital Learning, and Immersive Technology.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">From Talent to Leaders: Grooming Tomorrow's Leadership Internally</h2>
                <ul className="sight_1_topic_list">
                  <li>A dedicated piece on succession planning, internal promotions, and leadership development journeys at Novac.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">Employee Experience at the Core: How Novac Shapes Everyday Work Life</h2>
                <ul className="sight_1_topic_list">
                  <li>Highlight how culture, leadership accessibility, trust, and collaboration influence daily employee experiences.</li>
                </ul>
              </div>

              <div className="sight_1_topic_item">
                <h2 className="sight_1_topic_heading">The Future of Work at Novac: Innovation, Trust, and Sustainable Growth</h2>
                <ul className="sight_1_topic_list">
                  <li>A forward-looking blog on how Novac is preparing its people and culture to meet future workplace challenges.</li>
                </ul>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;